export const CREATE_WORKER_ATTENDANCE_DAILY = 'CREATE_WORKER_ATTENDANCE_DAILY';
export const GET_WORKER_ATTENDANCE_DAILY = 'GET_WORKER_ATTENDANCE_DAILY';
export const WORKER_ATTENDANCE_DAILY_REQUEST = 'WORKER_ATTENDANCE_DAILY_REQUEST';
export const UPDATE_WORKER_ATTENDANCE_DAILY = 'UPDATE_WORKER_ATTENDANCE_DAILY';
export const DELETE_WORKER_ATTENDANCE_DAILY = 'DELETE_WORKER_ATTENDANCE_DAILY';
export const WORKER_ATTENDANCE_DAILY_REQUEST_FAILURE = 'WORKER_ATTENDANCE_DAILY_REQUEST_FAILURE';